"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Search operations. */
var SearchImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Search class.
   * @param client Reference to the service client
   */
  function SearchImpl(client) {
    (0, _classCallCheck2["default"])(this, SearchImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param documentId
   * @param body Anything
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(SearchImpl, [{
    key: "getHighlights",
    value: function getHighlights(portalId, documentId, body, options) {
      var operationArguments = {
        portalId: portalId,
        documentId: documentId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getHighlightsOperationSpec);
    }
    /**
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getTerms",
    value: function getTerms(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getTermsOperationSpec);
    }
    /**
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getViews",
    value: function getViews(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getViewsOperationSpec);
    }
    /**
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getSearchFilterGroups",
    value: function getSearchFilterGroups(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSearchFilterGroupsOperationSpec);
    }
    /**
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getQueryRefinements",
    value: function getQueryRefinements(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getQueryRefinementsOperationSpec);
    }
    /**
     * @param portalId
     * @param body
     * @param options The options parameters.
     */

  }, {
    key: "exportToPdf",
    value: function exportToPdf(portalId, body, options) {
      var operationArguments = {
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, exportToPdfOperationSpec);
    }
    /**
     * @param portalId
     * @param body Anything
     * @param options The options parameters.
     */

  }, {
    key: "search",
    value: function search(portalId, body, options) {
      var operationArguments = {
        portalId: portalId,
        body: body,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, searchOperationSpec);
    }
  }]);
  return SearchImpl;
}(); // Operation Specifications


exports.SearchImpl = SearchImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getHighlightsOperationSpec = {
  path: "/api/Portals({portalId})/search/highlights/{documentId}",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  },
  requestBody: Parameters.body17,
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.documentId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};
var getTermsOperationSpec = {
  path: "/api/Portals({portalId})/search/terms",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "String"
            }
          }
        }
      }
    }
  },
  queryParameters: [Parameters.currentTerm, Parameters.limit],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getViewsOperationSpec = {
  path: "/api/Portals({portalId})/search/views",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchViewType"
            }
          }
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getSearchFilterGroupsOperationSpec = {
  path: "/api/Portals({portalId})/search/filterGroups",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchFilterGroupModel"
            }
          }
        }
      }
    }
  },
  queryParameters: [Parameters.searchPreviewName],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getQueryRefinementsOperationSpec = {
  path: "/api/Portals({portalId})/search/queryRefinements",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "SearchRefinementViewInfo"
            }
          }
        }
      }
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var exportToPdfOperationSpec = {
  path: "/api/Portals({portalId})/search/pdfExport",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Stream"
        },
        serializedName: "parsedResponse"
      }
    },
    206: {},
    406: {}
  },
  requestBody: Parameters.body22,
  queryParameters: [Parameters.languageCode],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.contentType, Parameters.accept1],
  mediaType: "json",
  serializer: serializer
};
var searchOperationSpec = {
  path: "/api/v1/portals/{portalId}/search",
  httpMethod: "POST",
  responses: {
    200: {
      bodyMapper: Mappers.SearchResponse
    }
  },
  requestBody: Parameters.body17,
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept, Parameters.contentType],
  mediaType: "json",
  serializer: serializer
};